import { getAuthHeaderRTK, getSessionId } from '@sky-uk/ita-js-common-token-manager';

import { getLogoutUrl, getTokenManagerAuthsUrl } from '../../utils/build-urls';
import { getCookie } from '../../utils/cookies';

export const getRequestOptions = ({
  method = 'GET',
  authorization,
  mode = 'cors',
  credentials = 'omit',
  body,
  accessToken,
}) => {
  const headersConfig = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  };
  if (authorization) {
    headersConfig.Authorization = authorization;
  }
  if (accessToken) {
    headersConfig.access_token = accessToken;
  }
  const headers = new Headers(headersConfig);
  const requestOptions = {
    method,
    headers,
    credentials,
    mode,
  };
  if (body) {
    requestOptions.body = body;
  }
  return requestOptions;
};

export const fetchTMApi = async ({ method, authorization, mode, credentials, data, sessionId }) => {
  const requestOptions = getRequestOptions({ method, authorization, mode, credentials, body: JSON.stringify(data) });
  const tokenManagerUrl = getTokenManagerAuthsUrl(sessionId);

  return fetch(tokenManagerUrl, requestOptions);
};

export const logoutCerbero = async () => {
  const JWTSessionID = getSessionId();
  const accessToken = getCookie('access_token');
  const authorization = getAuthHeaderRTK();
  const requestOptions = getRequestOptions({
    authorization,
    mode: 'cors',
    credentials: 'include',
    method: 'POST',
    accessToken,
    body: JSON.stringify({
      JWTSessionID,
    }),
  });
  const urlLogout = getLogoutUrl();
  return fetch(urlLogout, requestOptions);
};
